var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CarbonInventoryDialog',{attrs:{"visible":_vm.carbonInventoryVisible},on:{"close":_vm.closeCarbonInventory}}),_c('CarbonFootprintDialog',{attrs:{"visible":_vm.carbonFootprintVisible},on:{"close":_vm.closeCarbonFootprint}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }